import { FormTextField } from 'omakase';
import { core } from '@tock/coretypes';
import { getQuestionFieldName } from '@tock/shared/utils/questionUtils';
import { useTheme } from '@emotion/react';

interface Props {
  question: core.TicketTypeQuestion;
  multiline?: boolean;
}

/**
 * Formik field for text based pre-visit questions.
 * This is a text field decorated with a custom label.
 */
export const QuestionTextField = ({ question, multiline = false }: Props) => {
  const { id, text } = question;
  const { typography } = useTheme();

  return (
    <div data-testid="pre-visit-question">
      <label
        htmlFor={`question-${id}`}
        css={typography.variant('body02')}
        data-testid="pre-visit-question-label"
      >
        {text}
      </label>
      <FormTextField
        multiline={multiline}
        inputProps={{ 'data-testid': 'pre-visit-question-text' }}
        name={`${getQuestionFieldName(question)}.value`}
        id={`question-${id}`}
      />
    </div>
  );
};
